/**
 * PATH: apps/qa/src/lib/useQaAppCapabilities.ts
 * FILE_ID: QA-APP-CAPABILITIES-001
 * PURPOSE: Same capabilities query the job hub uses, through the QA api() client.
 */
import { useQuery } from '@tanstack/react-query'
import { qaCapabilitiesQueryKey, qaCapabilityFlags } from '@quotech/job-hub/jobs/qa'
import { api } from '@/lib/api'

export function useQaAppCapabilities(jobId?: number | null) {
  const query = useQuery({
    queryKey: qaCapabilitiesQueryKey(jobId),
    queryFn: async () => (
      await api().get('/qa/capabilities/', {
        params: jobId != null ? { job_id: jobId } : undefined,
      })
    ).data,
  })
  const status = query.isError ? 'error' : query.isSuccess ? 'success' : 'pending'
  return qaCapabilityFlags(query.data, status)
}
